import axios from 'axios';

const API_BASE_URL = 'https://evergreen-clinic-backend.onrender.com/api';

const API = axios.create({
  baseURL: API_BASE_URL,
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default API;
export { API_BASE_URL }; 